
// ModalEditarItensVenda.js

import React, { useState, useEffect } from 'react';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './ModalEditarItens.css';

function ModalEditarItensVenda({ isOpen, fecharModal, codVenda, dtvenda, codemp, codcli, onSave }) {
  const [produtos, setProdutos] = useState([]);
  const [itensVenda, setItensVenda] = useState([]);
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [quantidade, setQuantidade] = useState(1);
  const [valunit, setValunit] = useState(0.0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      console.log(`Modal opened for venda: ${codVenda}`);

      setItensVenda([]);

      api.get('/produtos/listarprodutos')
        
        .then(response => {
          setProdutos(response.data);
        })
        .catch(error => {
          console.error('Erro ao buscar produtos:', error);
        });

      api.get(`/vendasitem/${codVenda}/itens`)
        .then(response => {
          console.log(`Itens da venda ${codVenda}:`, response.data);
          setItensVenda(response.data);
        })
        .catch(error => {
          console.error('Erro ao buscar itens da venda:', error);
        });
    }
  }, [isOpen, codVenda]);

const handleAddItem = () => {
    console.log("Tentando adicionar item:", { selectedProduto, quantidade, valunit });

    if (selectedProduto && quantidade > 0 && valunit > 0) {
        const novoItem = {
            codpro: selectedProduto.id,
            produto: selectedProduto.produto,
            quantidade,
            valunit, // Usa o valor unitário atualizado
            valitem: quantidade * valunit, // Calcula o valor do item
            codemp: codemp,
            codcli: codcli,
            codVenda: codVenda,
            dtvenda: dtvenda
        };

        console.log("Novo item a ser adicionado:", novoItem);
        setItensVenda([...itensVenda, novoItem]);
        setQuantidade(1);
        setValunit(0.0);
        setSelectedProduto(null); // Reseta o produto selecionado
    } else {
        console.warn("Dados insuficientes para adicionar o item.");
    }
  };
  
  const handleRemoveItem = (index) => {
    const itemToRemove = itensVenda[index];
    if (itemToRemove.id) {
      api.delete(`/vendasitem/vendaitem/${itemToRemove.id}`)
        .then(() => {
          const novosItens = itensVenda.filter((_, i) => i !== index);
          setItensVenda(novosItens);
        })
        .catch(error => {
          console.error('Erro ao remover item da venda:', error);
        });
    } else {
      const novosItens = itensVenda.filter((_, i) => i !== index);
      setItensVenda(novosItens);
    }
  };

  const handleSave = () => {
    setLoading(true);
    const valorTotal = itensVenda.reduce((total, item) => total + item.valitem, 0);

    api.post(`/vendasitem/${codVenda}/itens`, itensVenda)
      
      .then(() => {
        return api.put(`/vendasitem/venda/${codVenda}/valor`, valorTotal);
      })
      .then(() => {
        onSave();
      })
      .catch(error => {
        console.error('Erro ao salvar itens da venda:', error);
      })
      .finally(() => {
        setLoading(false);
        fecharModal();
      });
  };

  const handleCloseModal = () => {
    setItensVenda([]);
    fecharModal();
  };

  // Função para lidar com a mudança do valor no input e formatar o valor
    const handleValorChange = (index, field, value) => {
    const updatedItensVenda = [...itensVenda];
    const item = updatedItensVenda[index];

    if (field === 'valunit') {
        // Remove caracteres não numéricos, exceto ponto (.) e vírgula (,)
        let numericValue = value.replace(/[^0-9,]/g, '').replace(',', '.');
        numericValue = parseFloat(numericValue);

        // Atualiza o valor unitário
        item.valunit = isNaN(numericValue) ? 0 : numericValue;

        // Recalcula o valor total do item
        item.valitem = item.quantidade * item.valunit;
    } else if (field === 'valitem') {
        // Remove caracteres não numéricos, exceto ponto (.) e vírgula (,)
        let numericValue = value.replace(/[^0-9,]/g, '').replace(',', '.');
        numericValue = parseFloat(numericValue);

        // Atualiza o valor total do item
        item.valitem = isNaN(numericValue) ? 0 : numericValue;

        // Recalcula o valor unitário com base no valor total e na quantidade
        item.valunit = item.quantidade > 0 ? item.valitem / item.quantidade : 0;
    } else {
        // Atualiza outros campos (ex: quantidade)
        item[field] = value;

        // Se a quantidade for alterada, recalcula o valor total do item
        if (field === 'quantidade') {
            item.valitem = item.quantidade * item.valunit;
        }
    }

    setItensVenda(updatedItensVenda);
  };

  // Função para formatar valores para o formato de moeda BRL
  const formatarValorInput = (valor) => {
    if (!valor) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={handleCloseModal}>&times;</span>

        <h3>Editando Itens da Venda: {codVenda}</h3>

        <div className="input-group">
          <div className="input-container">
            <label htmlFor="produto-select">Selecione um produto</label>

    <select
    id="produto-select"
    onChange={(e) => {
        const produtoId = e.target.value; // Captura o ID do produto selecionado
        const produtoSelecionado = produtos.find(produto => produto.id === parseInt(produtoId)); // Busca o produto completo na lista
        setSelectedProduto(produtoSelecionado); // Atualiza o estado do produto selecionado

        if (produtoSelecionado) {
            const valorVenda = parseFloat(produtoSelecionado.valvenda);
            setValunit(valorVenda); // Atualiza o valor unitário do estado
        } else {
            setValunit(0.0);
        }
    }}
    value={selectedProduto ? selectedProduto.id : ''} // Define o valor do select como o ID do produto selecionado
    >
    <option value="">-- Selecionar --</option>
    {produtos.map(produto => (
        <option key={produto.id} value={produto.id}>
            {produto.produto}
        </option>
    ))}
    </select>
            
          </div>

          <div className="input-container">
            <label htmlFor="quantidade-input">Quantidade</label>
            <input
              id="quantidade-input"
              type="number"
              value={quantidade}
              onChange={(e) => setQuantidade(parseInt(e.target.value, 10))}
              min="1"
              className="input-quantidade"
            />
          </div>

          <div className="input-container">
            <label htmlFor="valunit-input">Valor Unitário</label>

<input
    id="valunit-input"
    type="text"
    value={formatarValorInput(valunit)}
    onChange={(e) => {
        const formattedValue = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
        setValunit(parseFloat(formattedValue) / 100); // Converte para float
    }}
    className="input-valunit"
/>

          </div>

          <div className="input-container">
            <button className="botao-adicionar" onClick={handleAddItem}>Adicionar</button>
          </div>
        </div>

<table className="table-itensvenda">
    <colgroup>
        <col className="coluna-produto" />
        <col className="coluna-quantidade" />
        <col className="coluna-valunit" />
        <col className="coluna-valitem" />
        <col className="coluna-acoes" />
    </colgroup>
    <thead>
        <tr>
            <th>Produto</th>
            <th>Quantidade</th>
            <th translate="no">Valor Unitário</th>
            <th translate="no">Valor Item</th>
            <th>Ações</th>
        </tr>
    </thead>
    <tbody>
        {itensVenda && itensVenda.map((item, index) => (
            <tr key={index}>
                <td title={item.produto} className="btn-truncate">{item.produto}</td>
                <td>{item.quantidade}</td>
                <td>
                    <input
                        type="text"
                        value={formatarValorInput(item.valunit)}
                        onChange={(e) => handleValorChange(index, 'valunit', e.target.value)}
                        className="input-valunit"
                    />
                </td>
                <td>
                    <input
                        type="text"
                        value={formatarValorInput(item.valitem)}
                        onChange={(e) => handleValorChange(index, 'valitem', e.target.value)}
                        className="input-valitem"
                    />
                </td>
                <td>
                    <button className="button" onClick={() => handleRemoveItem(index)} translate="no">Remover</button>
                </td>
            </tr>
        ))}
    </tbody>
</table>        

        <div className="button-container">
          <button className="salvar" onClick={handleSave} disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalEditarItensVenda;